import topNav from "@/components/widgets/topNav.vue";
import  easySearch from "@/views/search/Research/easySearch/index.vue"
import  advancedSearch from "@/views/search/Research/advancedSearch/index.vue"
import imageSearch from "@/views/search/Research/imageSearch/index.vue"
import semanticRetrieve from "@/views/search/Research/semanticRetrieve/index.vue"
import easyinput from "@/views/search/Research/commponts/easyinput.vue"

export default {
    components: {
        topNav,
        easySearch,
        advancedSearch,
        imageSearch,
        semanticRetrieve,
        easyinput
    },
}